<script setup>
import { useConfirmation } from 'src/Composables/useConfirmation';


const { isOpen, props } = useConfirmation()
</script>

<template>
  <q-dialog v-model="isOpen" persistent backdrop-filter="blur(4px) saturate(0%)">
    <q-card style="max-width: 500px;" class="bg-red-1">
      <q-card-section class="row no-wrap">
        <q-icon :name="props.icon" color="primary" size="40px" class="q-mt-xs" />
        <div class="q-ml-sm">
          <div class="text-h6">{{props.title}}</div>
          <span>{{props.body}}</span>
        </div>
      </q-card-section>
      <q-separator color="primary" />
      <q-card-actions align="right" class="border-t">
        <q-btn flat :label="props?.buttonReject ?? 'NEIN'" color="primary" v-close-popup @click="() => { const error = new Error('User cancelled'); error.name = 'CancelError'; props?.rejectFn(error); }" />
        <q-btn flat :label="props?.buttonResolve ?? 'Ja'" color="primary" v-close-popup @click="props?.resolveFn" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
